import gql from 'graphql-tag';

export default gql`
    mutation EditLeapFrog($input: EditLeapFrogInput) {
        editLeapFrog(input: $input) {
            errors
        }
    }
`;
